import clsx from 'clsx';
import styles from './Eyebrow.module.css';

/**
 * Tank Redesign Eyebrow atom — uppercase mono section header.
 *
 * Source: ~/Downloads/tank-redesign/tokens.jsx → `Eyebrow` function.
 * Renders an optional `§ index` chip + a primary label. Used above section
 * headings and stat tiles.
 *
 * @param {Object} props
 * @param {React.ReactNode} [props.index] - optional § N prefix
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
export default function Eyebrow({ index, className, children, ...rest }) {
  return (
    <div className={clsx(styles.eyebrow, className)} {...rest}>
      {index != null && (
        <>
          <span className={styles.index}>§ {index}</span>
          <span className={styles.dot}>·</span>
        </>
      )}
      <span>{children}</span>
    </div>
  );
}
